import { Field } from "csi/def/Field";
import { View } from "csi/def/View";
import html from "csi/html";
import declare from "dojo/_base/declare";
import NewPaneForm from "./NewPaneForm";
import HomePageUtil from "./util";

const NewItemPaneForm = declare(NewPaneForm, {

	/**
	 * @override
	 * Return domain type for views (Style/Material).
	 */
	getDomainType(): string {
		return this.getFieldValue(HomePageUtil.DOMAIN);
	},

	/**
	 * @override
	 * Update available context types based on selected domain.
	 */
	onChangeDomain(defView: View, field: Field, value: any): void {
		this._updateContextTypes();
	},

	/**
	 * @override
	 * Update available domains based on selected pane.
	 */
	onChangePane(defView: View, field: Field, value: any): void {
		const paneTypes = this._getPaneContextTypes();
		const domainValue = this.getFieldValue(HomePageUtil.DOMAIN);
		const domainTypes = [];

		if (domainValue != null) {
			// convert context types for pane to domain types
			paneTypes.forEach((contextType) => {
				const domainType = this.getDomainTypeForContext(contextType);
				if (domainType && !domainTypes.includes(domainType)) {
					domainTypes.push(domainType);
				}
			});

			// update domain control
			const domainControl = this.getFieldControl(HomePageUtil.DOMAIN);
			const domainStore = this._getTypeStore(domainTypes);
			domainControl.set("store", domainStore);
			domainControl.set("value", this._getTypeStoreValue(domainStore, domainValue));

			// disable domain when there is only one choice
			html.setDisabled(domainControl, domainStore.query().length == 1);

			// hide HomePageUtil.DOMAIN field if no domain types to select, or if pane is not yet selected
			this.setFieldHidden(HomePageUtil.DOMAIN, paneTypes && (!domainTypes.length || domainTypes.length == 1));
		}

		this.inherited(arguments);
		this._updateContext();
	},
});

export = NewItemPaneForm;